import { Form, message, Row } from 'antd';
import React, { useEffect, useReducer } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import liracrypt from './Liracrypt/liracrypt';
import ZenFormInput from '../pages/InputCreater/ZenFormInput';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import queryString from 'query-string';
import Scanter from './STORM/Scanter';
const initialState = {
    barCodes: [],
    scanter: null,
    response: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "setBarCodes":
            return {
                ...state,
                barCodes: action.payload
            };
        case "setScanter":
            return {
                ...state,
                scanter: action.payload
            };
        case "setResponse":
            return {
                ...state,
                response: action.payload
            };
        default:
            return state;
    }

}
const ZenPopScanter = ({
    scanter,
    urlData,
    api,
    method = "POST",
    scanterCallback = () => { }
}) => {
    const _scanter = scanter || {
        "buttonProp": {
            "type": "primary",
            "label": "Scan Here",
            "visible": true,
            "enable": true,
            "validateFields": false,
            "confirmationPopUp": false,
            "submitFormData": true,
            "popUpModal": false,
            "postSubmitAction": false
        },
        "submitFormDataProp": {
            "method": method || "POST",
            "api": api || "/test",
            "params": {
                "param1": "p1",
                "param2": "p2"
            }
        }
    }
    const [form] = Form.useForm();
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const [barCode, setBarCode] = React.useState(null);
    const [pageData, dispatch] = useReducer(reducer, initialState);
    const [loading, setLoading] = React.useState(false);

    const queryElements = (controls) => {
        return (
            <Row justify={"center"}>
                {
                    controls.map((data, index) => {
                        if (dtArray.includes(data["typ"])) {

                            LocalDict[data["din"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                            LocalDict["din_from"] = data["din_from"];
                            LocalDict["din_to"] = data["din_to"];
                        }

                        if (data.visible) {
                            data.params = { ...searchParams, ...urlData, ...data.params, barCode: barCode };
                            data.sourceParams = { ...searchParams, ...urlData, ...data.params, barCode: barCode };
                            return (
                                <React.Fragment key={index}>
                                    <ZenFormInput
                                        //    urlData={{ ...urlData }}
                                        childType={data.childType}
                                        pageType={"zenForm"}
                                        header={data.header}
                                        footer={data.footer}
                                        labelColSpan={data["labelColSpan"]}
                                        style={data['style']}
                                        height={data['height']}
                                        layoutPosition="space-between"
                                        form={form}
                                        LocalDict={LocalDict}
                                        rows={data.rows}
                                        colSpan={data.colSize || 12}
                                        name={data["din"]}
                                        label={data["label"]}
                                        defaultValue={data["default"]}
                                        typ={data["typ"]}
                                        disabled={data["readOnly"]}
                                        source={data["source"]}
                                        sourceParams={data["sourceParams"]}
                                        auxParams={data["auxParams"]}
                                        format={data["format"]}
                                        errorMessage={data["errorMessage"]}
                                        placeHolder={data["placeHolder"]}
                                        required={data["required"]}
                                        options={data["data"]}
                                        from={data["din_from"]}
                                        to={data["din_to"]}
                                        url={data["url"]}
                                        includeAll={data["includeAll"]}
                                        pname={data["p_din"]}
                                        defaultFrom={data["defaultFrom"]}
                                        defaultTo={data["defaultTo"]}
                                        multiSelect={data["multiSelect"]}
                                        searchable={data["isSearchable"]}
                                        data={data}
                                        //   extraData={extraData}
                                        children={data['children']}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
            </Row>)
    }

    const onScanterFinish = async ({ values, button }) => {
        setLoading(true);
        let response;
        setBarCode(values.barCode);
        let { api, params, method } = button?.submitFormDataProp;
        // let postSubmitAction = button?.postSubmitActionProp[barCode] || button?.postSubmitActionProp.cmn;
        if (method === 'POST') {
            response = await liracrypt.post(api, { ...searchParams, ...urlData, ...params, ...values });
        };
        if (method === 'PATCH') {
            response = await liracrypt.patch(api, { ...searchParams, ...urlData, ...params, ...values });
        };
        if (method === 'GET') {
            response = await liracrypt.get(api, { ...searchParams, ...urlData, ...params, ...values });
        };
        try {
            if (response.data.isSuccess) {
                message.success(response.data.message || 'Scanned successfully!');
                dispatch({
                    type: "setResponse", payload: response.data.data
                });
                setLoading(false);
                scanterCallback();
            }
            else {
                message.error(response.data.message || 'Something went wrong!');
            }
        } catch (error) {
            console.error(error);
            ApiErrorComp();
        }
    }

    return (
        <div className="zenpop-scanter">

            <Scanter
                id="zen-pop-scanter"
                onFinish={onScanterFinish}
                postSubmitAction={() => { }}
                openPopupModal={() => { }}
                button={_scanter}
                // setSelectedButton={setSelectedButton}
                form={null}
                label={_scanter?.buttonProp?.label}
                type={_scanter?.buttonProp?.type}
                disabled={!_scanter?.buttonProp?.enable}
                confirmationPopUp={_scanter?.buttonProp?.confirmationPopUp ? _scanter?.confirmationPopUpProp : undefined}
                submitFormData={_scanter?.submitFormDataProp}
            />
            {
                loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <LoadingOutlined
                        style={{ fontSize: 80, color: "#007bff" }}
                        spin
                    /></div> :
                    pageData.response ?
                        <div className="scanter-response">
                            {queryElements(pageData.response)}
                        </div> : null
            }

        </div>
    )
};

export default ZenPopScanter;